import { BreadCrumbSign } from "../../components/generic/breadcrumbSign.component";
import { AddSuperAdmin } from "../../components/superAdmin/AddSuperAdmin.component";
export const SuperAdminAddPage = () => {
  return (
    <div className="row gx-0">
      <div className="col-12 m-2">
        <div className="d-flex flex-column px-1 me-3">
          <p className="content-header ms-1">
            Super Admin <BreadCrumbSign /> New
          </p>
          <AddSuperAdmin />
        </div>
      </div>
    </div>
  );
};
